//Action types
import { isScrollingDisabled } from '../../ducks/ui.duck';
import { fetchCurrentUser } from '../../ducks/user.duck';
import {
  onOrganizationCollectionCreate,
  onOrganizationCollectionUpdate,
} from '../../util/api';
import { storableError } from '../../util/errors';
import { parse } from '../../util/urlHelpers';
import { getSubscriptions, organizationCollections } from '../StripeSubscriptionPage/StripeSubscriptionPage.duck';

export const FETCH_SUBSCRIPTIONS_LOAD_DATA = 'app/StripeSubscriptionPage/FETCH_SUBSCRIPTIONS_LOAD_DATA';

export const FETCH_ORGANIZATION_REQUEST = 'app/StripeSubscriptionPage/FETCH_ORGANIZATION_REQUEST';
export const FETCH_ORGANIZATION_SUCCESS = 'app/StripeSubscriptionPage/FETCH_ORGANIZATION_SUCCESS';
export const FETCH_ORGANIZATION_ERROR = 'app/StripeSubscriptionPage/FETCH_ORGANIZATION_ERROR';


export const UPDATE_ORGANISATION_REQUEST = 'app/StripeSubscriptionPage/UPDATE_ORGANISATION_REQUEST';
export const UPDATE_ORGANISATION_SUCCESS = 'app/StripeSubscriptionPage/UPDATE_ORGANISATION_SUCCESS';
export const UPDATE_ORGANISATION_ERROR = 'app/StripeSubscriptionPage/UPDATE_ORGANISATION_ERROR';

export const CREATE_ORGANISATION_REQUEST = 'app/StripeSubscriptionPage/CREATE_ORGANISATION_REQUEST';
export const CREATE_ORGANISATION_ERROR = 'app/StripeSubscriptionPage/CREATE_ORGANISATION_ERROR'
export const CREATE_ORGANISATION_SUCCESS = 'app/StripeSubscriptionPage/CREATE_ORGANISATION_SUCCESS';

const initialState = {
  subscriptionLoadDataRequest: false,
  updateOrganisationRequest: false,
  updateOrganisationData: null,
  updateOrganisationError: null,
  createOrganisationRequest: false,
  createOrganisationError: null,
};

//Selectors
export const checkScrollingDisabled = state => isScrollingDisabled(state);
//reducer function
export default function reducer(state = initialState, action = {}) {
  const { type, payload } = action;
  switch (type) {

      case FETCH_SUBSCRIPTIONS_LOAD_DATA:
        return { ...state, subscriptionLoadDataRequest: payload }

      case UPDATE_ORGANISATION_REQUEST:
        return {
          ...state,
          updateOrganisationRequest: true,
          updateOrganisationError: null
        }

      case UPDATE_ORGANISATION_SUCCESS:
        return {
          ...state,
          updateOrganisationRequest: false,
          updateOrganisationData: payload,
          updateOrganisationError: null,
        }

      case UPDATE_ORGANISATION_ERROR:
        return {
          ...state,
          updateOrganisationRequest: false,
          updateOrganisationError: true,
        }
      case CREATE_ORGANISATION_REQUEST:
        return {
          ...state,
          createOrganisationRequest: true,
          createOrganisationError: false,
        }
    case CREATE_ORGANISATION_SUCCESS:
      return {
        ...state,
        createOrganisationRequest: false,
        createOrganisationError: false,
      };
      case CREATE_ORGANISATION_ERROR:
        return {
          ...state,
          createOrganisationRequest: false,
          createOrganisationError: true,
        }
    default:
      return state;
  }
}
// ================ Action creators ================ //

export const subscriptionLoadDataRequest = (data) => ({
  type: FETCH_SUBSCRIPTIONS_LOAD_DATA,
  payload: data,
});

export const updateOrganisationRequest = () => ({
  type: UPDATE_ORGANISATION_REQUEST,
})
export const updateOrganisationSuccess = (data) => ({
  type: UPDATE_ORGANISATION_SUCCESS,
  payload: data
})
export const updateOrganisationError = (e) => ({
  type: UPDATE_ORGANISATION_ERROR,
  payload: e,
})
export const createOrganisationRequest = (data) => ({
  type: CREATE_ORGANISATION_REQUEST,
  payload:data,
})
export const createOrganisationError = (e) => ({
  type: CREATE_ORGANISATION_ERROR,
  payload: e,
})
export const createOrganisationSuccess = () => ({
  type: CREATE_ORGANISATION_SUCCESS,
});
// ================ Thunk ================ //

export const onOrganizationCollectionData = (params) => async (dispatch, getState, sdk) => {
  const { requestLoader, id, ...rest } = params;
  try {
    dispatch(updateOrganisationRequest());
    const response = await onOrganizationCollectionUpdate({ id, ...rest }); // your existing call
    dispatch(updateOrganisationSuccess(response?.data || {}));
    return response;
  } catch (e) {
    console.error(e);
    dispatch(updateOrganisationError(e));
    return null;
  }
};


export const createOrganizationCollectionData = (params) => async (dispatch, getState, sdk) => {

  try {
    dispatch(createOrganisationRequest());
    const response = await onOrganizationCollectionCreate(params);
    dispatch(createOrganisationSuccess());
    return response;
  } catch (e) {
    console.error(e, '&&& &&& => e');
    dispatch(createOrganisationError(e));
    return storableError(e);
  }
};

export const ORG_PER_PAGE=10;
//LoadData
export const loadData = (params,search) => async (dispatch, getState, sdk) => {
  try {
    const {
      page = 1,
      sort="name_asc"
    } = parse(search)

    dispatch(subscriptionLoadDataRequest(true));
    const organizationParams = {
      payload: {
        isDelete: false
      },
      pageParams:{
        page:page,
        perPage:ORG_PER_PAGE
      },
      sort
    }
    return Promise.all([
      dispatch(fetchCurrentUser()),
    ]).then(async (response) => {
      const currentUser = getState().user?.currentUser;
      const {isOrganizationAdmin} = currentUser?.attributes?.profile?.privateData  || {};
      if (isOrganizationAdmin) {
        dispatch(organizationCollections(organizationParams))
      }
      dispatch(subscriptionLoadDataRequest(false));
      return response;
    })
  }
  catch (e) {
    dispatch(subscriptionLoadDataRequest(false));
  }
};
